import { Group, Radio, Stack, Text } from "@mantine/core";
import classes from "./RadioCard.module.css";
import { RadioCardProps } from "types/ui/radio-card";

const RadioCard: React.FC<RadioCardProps> = ({
  label = "",
  description = "",
  error = null,
  data = [],
  ...rest
}) => {
  const cards = data.map((item) => (
    <Radio.Card
      className={classes.root}
      radius="md"
      value={item.value}
      key={item.value}
    >
      <Group wrap="nowrap" align="flex-start">
        <Radio.Indicator />
        <div>
          <Text className={classes.label}>{item.name}</Text>
          <Text className={classes.description}>{item.description}</Text>
        </div>
      </Group>
    </Radio.Card>
  ));

  return (
    <>
      <Radio.Group label={label} description={description} {...rest}>
        {error && (
          <Text c="red" size="xs">
            {error}
          </Text>
        )}
        <Stack pt="md" gap="xs">
          {cards}
        </Stack>
      </Radio.Group>
    </>
  );
};

export default RadioCard;
